/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

function PinNumber({ registrationCode = '' }) {
  return (
    <p className="dtv-html5-c-activation-code">
      {registrationCode}
    </p>
  );
}

PinNumber.propTypes = {
  registrationCode: PropTypes.string,
};

export default memo(PinNumber);
